var map = {
	"./033-bm.webp": 1248,
	"./033-cn.webp": 1249,
	"./033.webp": 1250,
	"./13-bm.webp": 1251,
	"./13-cn.webp": 1252,
	"./13.webp": 1253,
	"./3-bm.webp": 1254,
	"./3-cn.webp": 1255,
	"./3.webp": 1256,
	"./angpao-bg-mobile.jpg": 1257,
	"./angpao-bg.jpg": 1258,
	"./angpao-bm.webp": 1259,
	"./angpao-cn.webp": 1260,
	"./angpao.webp": 1261,
	"./button.png": 1262,
	"./close-eye.png": 1263,
	"./coin-1.png": 1264,
	"./coin.png": 1265,
	"./ketupak-open.png": 1266,
	"./ketupak.png": 1267,
	"./ketupak_ribbon.png": 1268,
	"./rain-1.png": 1269,
	"./rain-2.png": 1270,
	"./rain-3.png": 1271,
	"./raya-bg-mobile.png": 1272,
	"./raya-bg.png": 1273,
	"./shine.png": 1274,
	"./star-1.png": 1275,
	"./star-2.png": 1276
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 362;